export const ALL_ITEM_DISPLAY = [
  {
    categry: "jewelryDisplay",
    itemList: [
      {
        itemSelected: "bambino",
        itemName: "Bambino",
        itemDescription:
          "Bambino is a jewelry display that comes with an acrylic cover to protect jewelry from dust. This piece is perfect for jewelers who want to make their store look luxurious.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Bambino/Desktop/700x700px/lussopack-jewelrydisplay-bambino-01.webp",
          "/images/listItem/jewelryDisplay/Bambino/Desktop/700x700px/lussopack-jewelrydisplay-bambino-02.webp",
          "/images/listItem/jewelryDisplay/Bambino/Desktop/700x700px/lussopack-jewelrydisplay-bambino-03.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Bambino/Desktop/130x130px/lussopack-jewelrydisplay-bambino-01.webp",
          "/images/listItem/jewelryDisplay/Bambino/Desktop/130x130px/lussopack-jewelrydisplay-bambino-02.webp",
          "/images/listItem/jewelryDisplay/Bambino/Desktop/130x130px/lussopack-jewelrydisplay-bambino-03.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Bambino/Mobile/335x335px/lussopack-jewelrydisplay-bambino-01.webp",
          "/images/listItem/jewelryDisplay/Bambino/Mobile/335x335px/lussopack-jewelrydisplay-bambino-02.webp",
          "/images/listItem/jewelryDisplay/Bambino/Mobile/335x335px/lussopack-jewelrydisplay-bambino-03.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Bambino/Mobile/100x100px/lussopack-jewelrydisplay-bambino-01.webp",
          "/images/listItem/jewelryDisplay/Bambino/Mobile/100x100px/lussopack-jewelrydisplay-bambino-02.webp",
          "/images/listItem/jewelryDisplay/Bambino/Mobile/100x100px/lussopack-jewelrydisplay-bambino-03.webp",
        ],
      },
      {
        itemSelected: "doice",
        itemName: "Doice",
        itemDescription:
          "Doice is a jewelry display that looks similar to the Bambino series but without an acrylic cover. This piece is perfect for jewelers who want to make their store look luxurious.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Doice/Desktop/700x700px/lussopack-jewelrydisplay-dolce-01.webp",
          "/images/listItem/jewelryDisplay/Doice/Desktop/700x700px/lussopack-jewelrydisplay-dolce-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Doice/Desktop/130x130px/lussopack-jewelrydisplay-dolce-01.webp",
          "/images/listItem/jewelryDisplay/Doice/Desktop/130x130px/lussopack-jewelrydisplay-dolce-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Doice/Mobile/335x335px/lussopack-jewelrydisplay-dolce-01.webp",
          "/images/listItem/jewelryDisplay/Doice/Mobile/335x335px/lussopack-jewelrydisplay-dolce-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Doice/Mobile/100x100px/lussopack-jewelrydisplay-dolce-01.webp",
          "/images/listItem/jewelryDisplay/Doice/Mobile/100x100px/lussopack-jewelrydisplay-dolce-02.webp",
        ],
      },
      {
        itemSelected: "gaia",
        itemName: "Gaia",
        itemDescription:
          "Gaia can be used to display many kinds of jewelry. It is the combination of steel, sponge, and velvet. Together with the Irene series, it is a perfect set.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Gaia/Desktop/700x700px/lussopack-jewelrydisplay-gaia-01.webp",
          "/images/listItem/jewelryDisplay/Gaia/Desktop/700x700px/lussopack-jewelrydisplay-gaia-02.webp",
          "/images/listItem/jewelryDisplay/Gaia/Desktop/700x700px/lussopack-jewelrydisplay-gaia-03.webp",
          "/images/listItem/jewelryDisplay/Gaia/Desktop/700x700px/lussopack-jewelrydisplay-gaia-04.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Gaia/Desktop/130x130px/lussopack-jewelrydisplay-gaia-01.webp",
          "/images/listItem/jewelryDisplay/Gaia/Desktop/130x130px/lussopack-jewelrydisplay-gaia-02.webp",
          "/images/listItem/jewelryDisplay/Gaia/Desktop/130x130px/lussopack-jewelrydisplay-gaia-03.webp",
          "/images/listItem/jewelryDisplay/Gaia/Desktop/130x130px/lussopack-jewelrydisplay-gaia-04.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Gaia/Mobile/335x335px/lussopack-jewelrydisplay-gaia-01.webp",
          "/images/listItem/jewelryDisplay/Gaia/Mobile/335x335px/lussopack-jewelrydisplay-gaia-02.webp",
          "/images/listItem/jewelryDisplay/Gaia/Mobile/335x335px/lussopack-jewelrydisplay-gaia-03.webp",
          "/images/listItem/jewelryDisplay/Gaia/Mobile/335x335px/lussopack-jewelrydisplay-gaia-04.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Gaia/Mobile/100x100px/lussopack-jewelrydisplay-gaia-01.webp",
          "/images/listItem/jewelryDisplay/Gaia/Mobile/100x100px/lussopack-jewelrydisplay-gaia-02.webp",
          "/images/listItem/jewelryDisplay/Gaia/Mobile/100x100px/lussopack-jewelrydisplay-gaia-03.webp",
          "/images/listItem/jewelryDisplay/Gaia/Mobile/100x100px/lussopack-jewelrydisplay-gaia-04.webp",
        ],
      },
      {
        itemSelected: "inaya",
        itemName: "Inaya",
        itemDescription:
          "Inaya is a unique and eye-catching earring display. This product can be customized and is perfect for customers who want something different.",

        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Inaya/Desktop/700x700px/lussopack-jewelrydisplay-inaya-01.webp",
          "/images/listItem/jewelryDisplay/Inaya/Desktop/700x700px/lussopack-jewelrydisplay-inaya-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Inaya/Desktop/130x130px/lussopack-jewelrydisplay-inaya-01.webp",
          "/images/listItem/jewelryDisplay/Inaya/Desktop/130x130px/lussopack-jewelrydisplay-inaya-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Inaya/Mobile/335x335px/lussopack-jewelrydisplay-inaya-01.webp",
          "/images/listItem/jewelryDisplay/Inaya/Mobile/335x335px/lussopack-jewelrydisplay-inaya-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Inaya/Mobile/100x100px/lussopack-jewelrydisplay-inaya-01.webp",
          "/images/listItem/jewelryDisplay/Inaya/Mobile/100x100px/lussopack-jewelrydisplay-inaya-02.webp",
        ],
      },
      {
        itemSelected: "irene",
        itemName: "Irene",
        itemDescription:
          "Irene can be used to display watches and bracelets. It is the combination of steel, sponge, and velvet.",

        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Irene/Desktop/700x700px/lussopack-jewelrydisplay-irene-01.webp",
          "/images/listItem/jewelryDisplay/Irene/Desktop/700x700px/lussopack-jewelrydisplay-irene-02.webp",
          "/images/listItem/jewelryDisplay/Irene/Desktop/700x700px/lussopack-jewelrydisplay-irene-03.webp",
          "/images/listItem/jewelryDisplay/Irene/Desktop/700x700px/lussopack-jewelrydisplay-irene-04.webp",
          "/images/listItem/jewelryDisplay/Irene/Desktop/700x700px/lussopack-jewelrydisplay-irene-05.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Irene/Desktop/130x130px/lussopack-jewelrydisplay-irene-01.webp",
          "/images/listItem/jewelryDisplay/Irene/Desktop/130x130px/lussopack-jewelrydisplay-irene-02.webp",
          "/images/listItem/jewelryDisplay/Irene/Desktop/130x130px/lussopack-jewelrydisplay-irene-03.webp",
          "/images/listItem/jewelryDisplay/Irene/Desktop/130x130px/lussopack-jewelrydisplay-irene-04.webp",
          "/images/listItem/jewelryDisplay/Irene/Desktop/130x130px/lussopack-jewelrydisplay-irene-05.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Irene/Mobile/335x335px/lussopack-jewelrydisplay-irene-01.webp",
          "/images/listItem/jewelryDisplay/Irene/Mobile/335x335px/lussopack-jewelrydisplay-irene-02.webp",
          "/images/listItem/jewelryDisplay/Irene/Mobile/335x335px/lussopack-jewelrydisplay-irene-03.webp",
          "/images/listItem/jewelryDisplay/Irene/Mobile/335x335px/lussopack-jewelrydisplay-irene-04.webp",
          "/images/listItem/jewelryDisplay/Irene/Mobile/335x335px/lussopack-jewelrydisplay-irene-05.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Irene/Mobile/100x100px/lussopack-jewelrydisplay-irene-01.webp",
          "/images/listItem/jewelryDisplay/Irene/Mobile/100x100px/lussopack-jewelrydisplay-irene-02.webp",
          "/images/listItem/jewelryDisplay/Irene/Mobile/100x100px/lussopack-jewelrydisplay-irene-03.webp",
          "/images/listItem/jewelryDisplay/Irene/Mobile/100x100px/lussopack-jewelrydisplay-irene-04.webp",
          "/images/listItem/jewelryDisplay/Irene/Mobile/100x100px/lussopack-jewelrydisplay-irene-05.webp",
        ],
      },
      {
        itemSelected: "livia",
        itemName: "Livia",
        itemDescription:
          "Livia is an earrings stand that creates a sophisticated appearance for jewelers. It is made with high quality materials to ensure that our customers will receive the best.",

        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Livia/Desktop/700x700px/lussopack-jewelrydisplay-livia.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Livia/Desktop/130x130px/lussopack-jewelrydisplay-livia.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Livia/Mobile/335x335px/lussopack-jewelrydisplay-livia.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Livia/Mobile/100x100px/lussopack-jewelrydisplay-livia.webp",
        ],
      },
      {
        itemSelected: "martina",
        itemName: "Martina",
        itemDescription:
          "Martina is a jewelry display set made from high-quality materials and designed by our professional designer team.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Martina/Desktop/700x700px/lussopack-jewelrydisplay-martina.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Martina/Desktop/130x130px/lussopack-jewelrydisplay-martina.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Martina/Mobile/335x335px/lussopack-jewelrydisplay-martina.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Martina/Mobile/100x100px/lussopack-jewelrydisplay-martina.webp",
        ],
      },
      {
        itemSelected: "rosa",
        itemName: "Rosa",
        itemDescription:
          "Rosa is a jewelry display set made from high-quality materials and designed by our professional designer team. ",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Rosa/Desktop/700x700px/lussopack-jewelrydisplay-rosa.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Rosa/Desktop/130x130px/lussopack-jewelrydisplay-rosa.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Rosa/Mobile/335x335px/lussopack-jewelrydisplay-rosa.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Rosa/Mobile/100x100px/lussopack-jewelrydisplay-rosa.webp",
        ],
      },
      {
        itemSelected: "silvia",
        itemName: "Silvia",
        itemDescription:
          "Silvia is a jewelry display set made from high-quality materials and designed by our professional designer team.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryDisplay/Silvia/Desktop/700x700px/lussopack-jewelrydisplay-silvia.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryDisplay/Silvia/Desktop/130x130px/lussopack-jewelrydisplay-silvia.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryDisplay/Silvia/Mobile/335x335px/lussopack-jewelrydisplay-silvia.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryDisplay/Silvia/Mobile/100x100px/lussopack-jewelrydisplay-silvia.webp",
        ],
      },
    ],
  },
];
